// import React, { useState, useEffect } from 'react';
// import { useLocation, useNavigate } from 'react-router-dom';
// import { useAuth } from '../../AuthContext';
// import {api} from '../Login/axiosConfig';
// import {
//   Box, Container, Typography, Grid, Card, Avatar,
//   Divider, Button, Checkbox, FormControlLabel,
//   TextField, Stack, CircularProgress, IconButton,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import Header1 from '../Header/Header1';
// import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import TimerIcon from '@mui/icons-material/Timer';
// import PersonIcon from '@mui/icons-material/Person';
// import EmailIcon from '@mui/icons-material/Email';
// import PhoneIcon from '@mui/icons-material/Phone';
// import LocalOfferIcon from '@mui/icons-material/LocalOffer';
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import dayjs from 'dayjs';

// const API_URL = process.env.REACT_APP_API_URL;

// // ─── Design tokens (matching existing palette) ────────────────────────────────
// const T = {
//   blue: '#1E90FF',
//   blueDim: 'rgba(30,144,255,0.08)',
//   blueBorder: 'rgba(30,144,255,0.2)',
//   green: '#00e676',
//   greenDim: 'rgba(0,230,118,0.08)',
//   greenBorder: 'rgba(0,230,118,0.22)',
//   surface: '#000000',
//   card: '#0d1117',
//   cardBorder: '#30363d',
//   divider: '#30363d',
//   text: '#c9d1d9',
//   textSub: '#8b949e',
//   textMuted: '#484f58',
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const fmtTime = (t) => {
//   if (!t) return '—';
//   const [h, m] = t.split(':');
//   const hour = parseInt(h, 10);
//   return `${hour % 12 || 12}:${m} ${hour >= 12 ? 'PM' : 'AM'}`;
// };

// const fmtDate = (d) => d ? dayjs(d).format('dddd, D MMMM YYYY') : '—';

// // ─── Section card wrapper ─────────────────────────────────────────────────────
// function SectionCard({ title, accent = T.blue, children }) {
//   return (
//     <motion.div whileHover={{ scale: 1.005 }} transition={{ type: 'spring', stiffness: 300 }}>
//       <Card sx={{
//         background: T.card,
//         border: `1px solid ${T.cardBorder}`,
//         borderRadius: '20px',
//         p: { xs: 2.5, sm: 3 },
//         boxShadow: '0 4px 32px rgba(0,0,0,0.45)',
//         position: 'relative',
//         overflow: 'hidden',
//         // top accent line
//         '&::before': {
//           content: '""',
//           position: 'absolute',
//           top: 0, left: '10%', right: '10%',
//           height: '1px',
//           background: `linear-gradient(90deg, transparent, ${accent}40, transparent)`,
//         },
//       }}>
//         <Typography sx={{
//           fontWeight: 700, fontSize: '0.72rem',
//           color: accent, letterSpacing: '0.1em',
//           textTransform: 'uppercase', mb: 2,
//         }}>
//           {title}
//         </Typography>
//         <Divider sx={{ background: T.divider, mb: 2.5 }} />
//         {children}
//       </Card>
//     </motion.div>
//   );
// }

// // ─── Info row inside cards ────────────────────────────────────────────────────
// function InfoRow({ icon, label, value, valueColor }) {
//   return (
//     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.8 }}>
//       <Box sx={{
//         width: 32, height: 32, flexShrink: 0,
//         borderRadius: '10px',
//         background: T.blueDim,
//         border: `1px solid ${T.blueBorder}`,
//         display: 'flex', alignItems: 'center', justifyContent: 'center',
//       }}>
//         {React.cloneElement(icon, { sx: { fontSize: 15, color: T.blue } })}
//       </Box>
//       <Box>
//         <Typography sx={{ fontSize: '0.68rem', color: T.textMuted, lineHeight: 1 }}>{label}</Typography>
//         <Typography sx={{ fontSize: '0.88rem', color: valueColor || T.text, fontWeight: 500, mt: '2px' }}>
//           {value || '—'}
//         </Typography>
//       </Box>
//     </Box>
//   );
// }

// // ─── Price row ────────────────────────────────────────────────────────────────
// function PriceRow({ label, value, highlight }) {
//   return (
//     <Box sx={{
//       display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//       py: 1, borderBottom: `1px solid ${T.divider}`,
//       '&:last-child': { borderBottom: 'none' },
//     }}>
//       <Typography sx={{ fontSize: '0.82rem', color: T.textSub }}>{label}</Typography>
//       <Typography sx={{
//         fontSize: highlight ? '1rem' : '0.88rem',
//         fontWeight: highlight ? 700 : 500,
//         color: highlight ? T.green : T.text,
//       }}>
//         {value}
//       </Typography>
//     </Box>
//   );
// }

// // ─── Main page ────────────────────────────────────────────────────────────────
// export default function SessionCheckout({ onLogout }) {
//   const { state } = useLocation();
//   const navigate = useNavigate();
//   const { userId } = useAuth();

//   // State passed from BookingModal
//   const { expert, date, time, duration, price: basePrice, appointmentTypeId } = state || {};
//   const [backendPrice, setBackendPrice] = useState(null);
//   const [userData, setUserData] = useState({ name: '', surname: '', email: '', contact: '' });
//   const [isChecked, setIsChecked] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [couponCode, setCouponCode] = useState('');
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [couponPct, setCouponPct] = useState(0);
//   const [csrfToken, setCsrfToken] = useState('');

//   // Pricing
//   const GST_RATE = 0.18;
//   const GATEWAY_RATE = 0.02;
//   const gst = parseFloat((basePrice * GST_RATE).toFixed(2));
//   const subtotal = parseFloat((basePrice + gst).toFixed(2));
//   const discounted = couponApplied
//     ? parseFloat((subtotal * (1 - couponPct / 100)).toFixed(2))
//     : subtotal;
//   const gateway = parseFloat((discounted * GATEWAY_RATE).toFixed(2));
//   const totalPay = parseFloat((discounted + gateway).toFixed(2));

//   // Fetch user data + CSRF
//   useEffect(() => {
//     if (!userId) return;
//     api.get(`${API_URL}/get_user_data/?user_id=${userId}`)
//       .then(res => setUserData(res.data))
//       .catch(console.error);

//     api.get(`${API_URL}/get-csrf-token/`, { withCredentials: true })
//       .then(res => setCsrfToken(res.data.csrfToken))
//       .catch(console.error);
//   }, [userId]);

//   // Coupon
//   const handleApplyCoupon = async () => {
//     if (!couponCode.trim()) { alert('Enter a coupon code.'); return; }
//     setLoading(true);
//     try {
//       const res = await api.post(`${API_URL}/api/validate-coupon/`, { coupon_code: couponCode });
//       if (res.status === 200) {
//         setCouponPct(res.data.discount);
//         setCouponApplied(true);
//       }
//     } catch {
//       alert('Invalid or expired coupon.');
//     } finally { setLoading(false); }
//   };

//   const handleRemoveCoupon = () => {
//     setCouponCode(''); setCouponApplied(false); setCouponPct(0);
//   };

//   // ── Razorpay payment (same flow as BookingModal) ──────────────────────────
//   // const handlePay = async () => {
//   //   if (!isChecked) return;
//   //   setLoading(true);
//   //   try {
//   //     // 1. Create order
//   //     const orderRes = await api.post(
//   //       `${API_URL}/create-order/`,
//   //       { amount: Math.round(totalPay * 100) },
//   //       { headers: { 'X-CSRFToken': csrfToken }, withCredentials: true }
//   //     );
//   //     const { id: orderId } = orderRes.data;
//   //     if (!orderId) throw new Error('Order creation failed');

//   //     // 2. Load Razorpay SDK
//   //     await new Promise(resolve => {
//   //       if (window.Razorpay) return resolve();
//   //       const s = document.createElement('script');
//   //       s.src = 'https://checkout.razorpay.com/v1/checkout.js';
//   //       s.onload = resolve;
//   //       document.body.appendChild(s);
//   //     });

//   //     // 3. Open Razorpay
//   //     const options = {
//   //       key:         'rzp_live_7e0OC9qGVaGXLr',
//   //       amount:      Math.round(totalPay * 100),
//   //       currency:    'INR',
//   //       name:        'Anthrasync',
//   //       description: `Session with ${expert?.name}`,
//   //       order_id:    orderId,
//   //       prefill:     { name: userData.name, email: userData.email, contact: userData.contact },
//   //       theme:       { color: T.blue },

//   //       handler: async (razorpayRes) => {
//   //         // 4. Verify payment
//   //         const verifyRes = await fetch(`${API_URL}/verify-payment/`, {
//   //           method: 'POST',
//   //           headers: {
//   //             'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//   //             'Content-Type': 'application/json',
//   //           },
//   //           body: JSON.stringify({
//   //             razorpay_payment_id: razorpayRes.razorpay_payment_id,
//   //             razorpay_order_id:   razorpayRes.razorpay_order_id,
//   //             razorpay_signature:  razorpayRes.razorpay_signature,
//   //           }),
//   //         });
//   //         const result = await verifyRes.json();
//   //         if (result.success) {
//   //           navigate('/booking-success', {
//   //             state: { paymentId: razorpayRes.razorpay_payment_id, expert, date, time },
//   //           });
//   //         }
//   //       },

//   //       modal: {
//   //         ondismiss: () => {
//   //           alert('Payment cancelled.');
//   //           setLoading(false);
//   //         },
//   //       },
//   //     };

//   //     new window.Razorpay(options).open();

//   //   } catch (err) {
//   //     alert('Payment failed: ' + err.message);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handlePay = async () => {
//     if (!isChecked) return;
//     setLoading(true);

//     try {
//       // 1. Create order — backend calculates price from expert + type
//       const orderRes = await fetch(`${API_URL}/create-order/`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//           'Content-Type': 'application/json',
//         },
//        body: JSON.stringify({
//         amount: Math.round(totalPay * 100),
//   expert_id: expert?.id,
//   appointment_type_id: appointmentTypeId,
//   date,
//   time,
//   notes: state?.notes || '',
//   coupon_code: couponApplied ? couponCode : null,
// }),
//       });

//       if (!orderRes.ok) {
//         const txt = await orderRes.text();
//         throw new Error(`Order failed (${orderRes.status}): ${txt}`);
//       }
//       const resData = await orderRes.json();

// const {
//   order_id,
//   amount,
//   currency,
//   key,
//   booking_id,
//   name,
//   email,
//   contact,
//   breakdown
// } = resData;
// setBackendPrice(breakdown);
//       // const { order_id, amount, currency, key, booking_id, name, email, contact } = await orderRes.json();
//       console.log('booking_id from order:', booking_id);
//       console.log('Razorpay key from backend:', key);
//       if (!order_id) throw new Error('No order_id returned from server');

//       // 2. Load Razorpay SDK once
//       await new Promise((resolve) => {
//         if (window.Razorpay) return resolve();
//         const s = document.createElement('script');
//         s.src = 'https://checkout.razorpay.com/v1/checkout.js';
//         s.onload = resolve;
//         document.body.appendChild(s);
//       });

//       // 3. Open Razorpay
//       const options = {
//         key,
//         amount: Math.round(totalPay * 100),
//         currency,
//         order_id,
//         name: 'Anthrasync',
//         description: `Session with ${expert?.name}`,
//         prefill: { name, email, contact },
//         theme: { color: T.blue },

//         // 4. On payment success → verify
//         handler: async (rzpRes) => {


//           try {
//             const verifyRes = await fetch(`${API_URL}/verify-payment/`, {
//               method: 'POST',
//               headers: {
//                 'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
//                 'Content-Type': 'application/json',
//               },
//               body: JSON.stringify({
//                 razorpay_payment_id: rzpRes.razorpay_payment_id,
//                 razorpay_order_id: rzpRes.razorpay_order_id,
//                 razorpay_signature: rzpRes.razorpay_signature,
//                 booking_id,

//               }),

//             });
//             console.log('booking_id being sent:', booking_id);
//             console.log('rzpRes:', rzpRes);

//             if (!verifyRes.ok) throw new Error('Payment verification failed');

//             const result = await verifyRes.json();
//             console.log('✅ Verify response status:', verifyRes.status);
//             console.log('✅ Verify result:', result);
//             if (result.success) {
//               console.log('🎉 Payment verified! Booking ID:', result.booking_id);
//               await api.post(`${API_URL}/create_transactions_session_booking/`, {
//                 user_id: userId,
//                 booking_id: result.booking_id,
//                 order_id: rzpRes.razorpay_order_id,
//                 transaction_id: rzpRes.razorpay_payment_id,
//                 amount: totalPay,
//                 status: 'success',
//                 payment_reason: 'Session Booking',
//               }, {
//                 headers: {
//                   Authorization: `Bearer ${localStorage.getItem('access_token')}`,  // ← add this
//                 },
//               }).then(res => console.log('✅ Transaction saved:', res.data))
//                 .catch(err => console.log('❌ Transaction error:', err.response?.data));;
//               // 5. Navigate to success page
//               navigate('/transactions', {
//                 state: {
//                   paymentId: rzpRes.razorpay_payment_id,
//                   expert,
//                   date,
//                   time,
//                 },
//               });
//             } else {
//               alert('Payment verified but booking failed. Contact support.');
//             }
//           } catch (err) {
//             alert('Verification error: ' + err.message);
//           } finally {
//             setLoading(false);
//           }
//         },

//         modal: {
//           ondismiss: async () => {
//             try {
//               await api.post(`${API_URL}/create_transactions_session_booking/`, {
//                 user_id: userId,
//                 booking_id: booking_id, // ✅ already available
//                 order_id: order_id,     // ✅ already available
//                 transaction_id: null,
//                 amount: breakdown.final_amount,
//                 status: 'failure',
//                 payment_reason: 'Session Booking',
//               }, {
//                 headers: {
//                   Authorization: `Bearer ${localStorage.getItem('access_token')}`,  // ← add this
//                 },
//               });
//             } catch (err) {
//               console.error('Failed to save cancelled transaction', err);
//             }
//             alert('Payment cancelled.');

//             setLoading(false);
//           },
//         },
//       };

//       new window.Razorpay(options).open();

//     } catch (err) {
//       alert('Payment failed: ' + err.message);
//       setLoading(false);
//     }
//   };

//   const handlePhonePePayment = async () => {
//   if (!isChecked) return;

//   try {
//     setLoading(true);

//     // 🔥 Create PhonePe payment
//     const res = await api.post(`${API_URL}/phonepe-payment/`, {
//       amount: totalPay,
//     });

//     const redirectUrl = res.data?.redirectUrl;
//     const orderId = res.data?.orderId;

//     // 🔥 Save data for success page
//     localStorage.setItem("phonepe_order_id", orderId);

//     localStorage.setItem("phonepe_payment_data", JSON.stringify({
//       user_id: userId,
//       booking_id: state?.booking_id || null,
//       amount: totalPay,
//       plan: "Session Booking"
//     }));

//     if (redirectUrl) {
//       window.location.href = redirectUrl;
//     } else {
//       alert("PhonePe initialization failed");
//       setLoading(false);
//     }

//   } catch (err) {
//     console.error(err);
//     alert("PhonePe payment failed");
//     setLoading(false);
//   }
// };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 20 },
//     visible: (i) => ({ opacity: 1, y: 0, transition: { delay: i * 0.1, duration: 0.4, ease: 'easeOut' } }),
//   };

//   return (
//     <Box sx={{ minHeight: '100vh', background: T.surface, color: T.text }}>

//       {/* Header */}
//       <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1300 }}>
//         <Header1 onLogout={onLogout} />
//       </Box>

//       <Container maxWidth="md" sx={{ pt: { xs: 10, sm: 12 }, pb: 10, px: { xs: 2, sm: 3 } }}>

//         {/* Page heading */}
//         <Box sx={{ textAlign: 'center', mb: { xs: 5, sm: 6 } }}>
//           <Typography sx={{
//             fontWeight: 800, fontSize: { xs: '1.6rem', sm: '2rem' },
//             background: 'linear-gradient(90deg, #c8d0e8, #4f9eff)',
//             WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
//             letterSpacing: '-0.01em',
//           }}>
//             Session Checkout
//           </Typography>
//           <Typography sx={{ color: T.textSub, fontSize: '0.88rem', mt: 1 }}>
//             Review your booking before payment
//           </Typography>
//         </Box>

//         <Grid container spacing={{ xs: 2.5, sm: 3 }} justifyContent="center">

//           {/* ── LEFT COLUMN ── */}
//           <Grid item xs={12} md={5}>
//             <Stack spacing={2.5}>

//               {/* 1. Order Info */}
//               <motion.div custom={0} variants={cardVariants} initial="hidden" animate="visible">
//                 <SectionCard title="Session Summary" accent={T.blue}>

//                   {/* Expert strip */}
//                   <Box sx={{
//                     display: 'flex', alignItems: 'center', gap: 1.5,
//                     p: 2, mb: 2.5,
//                     borderRadius: '14px',
//                     background: 'rgba(79,158,255,0.04)',
//                     border: `1px solid ${T.blueBorder}`,
//                   }}>
//                     <Avatar
//                       src={expert?.image || undefined}
//                       sx={{
//                         width: 48, height: 48, flexShrink: 0,
//                         background: 'linear-gradient(135deg,#0d2145,#1a3a6e)',
//                         color: '#6ea8ff', fontWeight: 700,
//                         border: `1.5px solid ${T.blueBorder}`,
//                       }}
//                     >
//                       {!expert?.image && expert?.name?.charAt(0).toUpperCase()}
//                     </Avatar>
//                     <Box>
//                       <Typography sx={{ fontWeight: 600, color: T.text, fontSize: '0.92rem' }}>
//                         {expert?.name}
//                       </Typography>
//                       <Typography sx={{ color: '#4da3ff', fontSize: '0.72rem' }}>
//                         {expert?.title}
//                       </Typography>
//                     </Box>
//                   </Box>

//                   <InfoRow icon={<CalendarMonthIcon />} label="Date" value={fmtDate(date)} />
//                   <InfoRow icon={<AccessTimeIcon />} label="Time" value={fmtTime(time)} />
//                   <InfoRow icon={<TimerIcon />} label="Duration" value={duration} />
//                   <InfoRow
//                     icon={<LocalOfferIcon />}
//                     label="Session Price"
//                     value={`₹${basePrice}`}
//                     valueColor={T.green}
//                   />
//                 </SectionCard>
//               </motion.div>

//               {/* 2. Personal Info */}
//               <motion.div custom={1} variants={cardVariants} initial="hidden" animate="visible">
//                 <SectionCard title="Personal Info" accent={T.blue}>
//                   <InfoRow icon={<PersonIcon />} label="Full Name" value={`${userData.name} ${userData.surname}`.trim()} />
//                   <InfoRow icon={<EmailIcon />} label="Email" value={userData.email} />
//                   <InfoRow icon={<PhoneIcon />} label="Contact" value={userData.contact} />
//                 </SectionCard>
//               </motion.div>

//             </Stack>
//           </Grid>

//           {/* ── RIGHT COLUMN ── */}
//           <Grid item xs={12} md={5}>
//             <Stack spacing={2.5}>

//               {/* 3. Pricing & Coupon */}
//               <motion.div custom={2} variants={cardVariants} initial="hidden" animate="visible">
//                 <SectionCard title="Pricing" accent={T.blue}>
//                   <PriceRow label="Base Price" value={`₹${basePrice}`} />
//                   <PriceRow label="GST (18%)" value={`₹${backendPrice?.gst || gst}`} />
//                   {couponApplied && (
//                     <PriceRow label={`Coupon (${couponPct}% off)`} value={`-₹${(subtotal * couponPct / 100).toFixed(2)}`} />
//                   )}
//                   <PriceRow label="Gateway Fee (2%)" value={`₹${backendPrice?.gateway_fee || gateway}`} />
//                   <PriceRow label="Total Payable" value={`₹${backendPrice?.final_amount ||totalPay}`} highlight />

//                   {/* Coupon section */}
//                   <Box sx={{ mt: 2.5 }}>
//                     {couponApplied ? (
//                       <Box sx={{
//                         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//                         px: 2, py: 1.2,
//                         borderRadius: '12px',
//                         background: T.greenDim,
//                         border: `1px solid ${T.greenBorder}`,
//                       }}>
//                         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                           <CheckCircleIcon sx={{ fontSize: 16, color: T.green }} />
//                           <Typography sx={{ fontSize: '0.82rem', color: T.green, fontWeight: 600 }}>
//                             {couponPct}% off applied
//                           </Typography>
//                         </Box>
//                         <Button
//                           size="small" onClick={handleRemoveCoupon}
//                           sx={{
//                             fontSize: '0.72rem', color: '#ff6b6b', textTransform: 'none', p: 0,
//                             '&:hover': { color: '#ff4444' },
//                           }}
//                         >
//                           Remove
//                         </Button>
//                       </Box>
//                     ) : (
//                       <Box sx={{ display: 'flex', gap: 1 }}>
//                         <TextField
//                           fullWidth size="small"
//                           placeholder="Coupon code"
//                           value={couponCode}
//                           onChange={e => setCouponCode(e.target.value)}
//                           sx={{
//                             '& .MuiOutlinedInput-root': {
//                               borderRadius: '12px',
//                               background: 'rgba(255,255,255,0.03)',
//                               color: T.text, fontSize: '0.85rem',
//                               '& fieldset': { borderColor: T.cardBorder },
//                               '&:hover fieldset': { borderColor: T.blueBorder },
//                               '&.Mui-focused fieldset': { borderColor: T.blue },
//                             },
//                             '& input::placeholder': { color: T.textMuted },
//                             '& input': { color: T.text },
//                           }}
//                         />
//                         <Button
//                           variant="outlined" onClick={handleApplyCoupon}
//                           sx={{
//                             borderRadius: '12px', px: 2.5, flexShrink: 0,
//                             fontSize: '0.8rem', fontWeight: 600, textTransform: 'none',
//                             color: T.blue, borderColor: T.blueBorder,
//                             '&:hover': { background: T.blueDim, borderColor: T.blue },
//                           }}
//                         >
//                           Apply
//                         </Button>
//                       </Box>
//                     )}
//                   </Box>
//                 </SectionCard>
//               </motion.div>

//               {/* 4. Confirm & Pay */}
//               <motion.div custom={3} variants={cardVariants} initial="hidden" animate="visible">
//                 <SectionCard title="Confirm & Pay" accent={T.green}>

//                   {/* Final price summary */}
//                   <Box sx={{
//                     px: 2.5, py: 2,
//                     borderRadius: '14px',
//                     background: T.greenDim,
//                     border: `1px solid ${T.greenBorder}`,
//                     display: 'flex', justifyContent: 'space-between', alignItems: 'center',
//                     mb: 2.5,
//                   }}>
//                     <Typography sx={{ fontSize: '0.82rem', color: T.textSub }}>Total Payable</Typography>
//                     <Typography sx={{ fontSize: '1.5rem', fontWeight: 800, color: T.green }}>
//                       ₹{backendPrice?.final_amount || totalPay}
//                     </Typography>
//                   </Box>

//                   <FormControlLabel
//                     control={
//                       <Checkbox
//                         checked={isChecked}
//                         onChange={e => setIsChecked(e.target.checked)}
//                         sx={{
//                           color: T.textMuted,
//                           '&.Mui-checked': { color: T.blue },
//                           '& .MuiSvgIcon-root': { fontSize: 18 },
//                         }}
//                       />
//                     }
//                     label={
//                       <Typography sx={{ fontSize: '0.8rem', color: T.textSub }}>
//                         I confirm the booking details are correct
//                       </Typography>
//                     }
//                     sx={{ mb: 2.5, alignItems: 'flex-start', '& .MuiFormControlLabel-label': { mt: '1px' } }}
//                   />

//                   <Button
//                     fullWidth variant="contained"
//                     onClick={handlePay}
//                     disabled={!isChecked || loading}
//                     startIcon={loading ? <CircularProgress size={16} sx={{ color: 'inherit' }} /> : null}
//                     sx={{
//                       borderRadius: '14px', py: 1.4,
//                       fontSize: '0.9rem', fontWeight: 700, textTransform: 'none',
//                       letterSpacing: '0.02em',
//                       background: isChecked
//                         ? 'linear-gradient(90deg, #00b85a, #00e676)'
//                         : 'rgba(0,230,118,0.08)',
//                       boxShadow: isChecked ? '0 6px 24px rgba(0,230,118,0.28)' : 'none',
//                       color: isChecked ? '#001a0d' : T.textMuted,
//                       border: `1px solid ${isChecked ? 'rgba(0,230,118,0.3)' : T.cardBorder}`,
//                       transition: 'all 0.22s ease',
//                       '&:hover': {
//                         background: 'linear-gradient(90deg, #00cc66, #00ff88)',
//                         boxShadow: '0 8px 32px rgba(0,230,118,0.38)',
//                         transform: 'translateY(-1px)',
//                       },
//                       '&:active': { transform: 'scale(0.98)' },
//                       '&:disabled': {
//                         background: 'rgba(0,230,118,0.06)',
//                         color: T.textMuted, boxShadow: 'none',
//                       },
//                     }}
//                   >
//                     {loading ? 'Processing…' : 'Pay Now'}
//                   </Button>
//                   <Button
//   fullWidth
//   variant="outlined"
//   onClick={handlePhonePePayment}
//   disabled={!isChecked || loading}
//   sx={{
//     mt: 1.5,
//     borderRadius: '14px',
//     py: 1.4,
//     fontSize: '0.9rem',
//     fontWeight: 700,
//     textTransform: 'none',
//     color: '#5f259f',
//     borderColor: '#5f259f',
//     '&:hover': {
//       background: 'rgba(95,37,159,0.1)',
//       borderColor: '#5f259f'
//     }
//   }}
// >
//   Pay with PhonePe
// </Button>

//                   <Typography sx={{
//                     textAlign: 'center', fontSize: '0.7rem',
//                     color: T.textMuted, mt: 1.5,
//                   }}>
//                     Secured by Razorpay · 256-bit SSL
//                   </Typography>
//                 </SectionCard>
//               </motion.div>

//             </Stack>
//           </Grid>
//         </Grid>
//       </Container>

//       {/* Scroll to top */}
//       <IconButton
//         onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
//         sx={{
//           position: 'fixed', bottom: 20, right: 20,
//           background: 'rgba(79,158,255,0.12)',
//           border: `1px solid ${T.blueBorder}`,
//           color: T.blue,
//           '&:hover': { background: T.blueDim },
//         }}
//       >
//         <ArrowUpwardIcon sx={{ fontSize: 18 }} />
//       </IconButton>

//       {/* Full-screen loading overlay */}
//       {loading && (
//         <Box sx={{
//           position: 'fixed', inset: 0, zIndex: 2000,
//           background: 'rgba(4,5,12,0.75)',
//           backdropFilter: 'blur(6px)',
//           display: 'flex', alignItems: 'center', justifyContent: 'center',
//           flexDirection: 'column', gap: 2,
//         }}>
//           <CircularProgress size={52} thickness={5} sx={{
//             color: 'transparent',
//             '& .MuiCircularProgress-circle': { stroke: 'url(#pg)' },
//           }} />
//           <svg width="0" height="0">
//             <defs>
//               <linearGradient id="pg" x1="1" y1="0" x2="0" y2="1">
//                 <stop offset="0%" stopColor="#4f9eff" />
//                 <stop offset="100%" stopColor="#00e676" />
//               </linearGradient>
//             </defs>
//           </svg>
//           <Typography sx={{ color: T.text, fontSize: '0.88rem' }}>Processing…</Typography>
//         </Box>
//       )}
//     </Box>
//   );
// }


import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { api } from '../Login/axiosConfig';
import {
  Box, Container, Typography, Grid, Card, Avatar,
  Divider, Button, Checkbox, FormControlLabel,
  TextField, Stack, CircularProgress, IconButton,
  Chip, Tooltip
} from '@mui/material';
import { motion } from 'framer-motion';
import Header1 from '../Header/Header1';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerIcon from '@mui/icons-material/Timer';
import PersonIcon from '@mui/icons-material/Person';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import dayjs from 'dayjs';

const API_URL = process.env.REACT_APP_API_URL;

const T = {
  blue: '#1E90FF',
  blueDim: 'rgba(30,144,255,0.08)',
  blueBorder: 'rgba(30,144,255,0.2)',
  green: '#00e676',
  greenDim: 'rgba(0,230,118,0.08)',
  greenBorder: 'rgba(0,230,118,0.22)',
  red: '#ff6b6b',
  surface: '#02040a',
  card: '#0d1117',
  cardSoft: 'rgba(13,17,23,0.85)',
  cardBorder: '#30363d',
  divider: '#21262d',
  text: '#c9d1d9',
  textSub: '#8b949e',
  textMuted: '#6e7681',
};

const fmtTime = (t) => {
  if (!t) return '—';
  const [h, m] = t.split(':');
  const hour = parseInt(h, 10);
  return `${hour % 12 || 12}:${m} ${hour >= 12 ? 'PM' : 'AM'}`;
};

const fmtDate = (d) => (d ? dayjs(d).format('dddd, D MMMM YYYY') : '—');

// Generic section card
function SectionCard({ title, subtitle, accent = T.blue, children, dense }) {
  return (
    <motion.div
      whileHover={{ scale: 1.004 }}
      transition={{ type: 'spring', stiffness: 260, damping: 20 }}
    >
      <Card
        sx={{
          background: T.cardSoft,
          border: `1px solid ${T.cardBorder}`,
          borderRadius: '20px',
          p: dense ? 2 : { xs: 2.5, sm: 3 },
          boxShadow: '0 24px 80px rgba(0,0,0,0.55)',
          position: 'relative',
          overflow: 'hidden',
          '&::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at top left, rgba(56,139,253,0.16), transparent 55%)',
            opacity: 0.8,
            pointerEvents: 'none',
          },
        }}
      >
        <Box sx={{ position: 'relative', zIndex: 1 }}>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: '0.7rem',
              color: accent,
              letterSpacing: '0.16em',
              textTransform: 'uppercase',
            }}
          >
            {title}
          </Typography>
          {subtitle && (
            <Typography
              sx={{
                mt: 0.5,
                fontSize: '0.78rem',
                color: T.textMuted,
              }}
            >
              {subtitle}
            </Typography>
          )}
          <Divider sx={{ background: T.divider, my: dense ? 1.8 : 2.4 }} />
          {children}
        </Box>
      </Card>
    </motion.div>
  );
}

// Small info row
function InfoRow({ icon, label, value, valueColor, pill }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        mb: 1.6,
      }}
    >
      <Box
        sx={{
          width: 32,
          height: 32,
          flexShrink: 0,
          borderRadius: '32%',
          background: 'rgba(56,139,253,0.12)',
          border: `1px solid ${T.blueBorder}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {React.cloneElement(icon, {
          sx: { fontSize: 16, color: T.blue },
        })}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: '0.72rem',
            color: T.textMuted,
            lineHeight: 1.1,
          }}
        >
          {label}
        </Typography>
        {pill ? (
          <Chip
            size="small"
            label={value || '—'}
            sx={{
              mt: 0.5,
              maxWidth: '100%',
              fontSize: '0.8rem',
              background: 'rgba(99,171,255,0.16)',
              color: T.text,
              borderRadius: '999px',
            }}
          />
        ) : (
          <Typography
            sx={{
              fontSize: '0.9rem',
              color: valueColor || T.text,
              fontWeight: 500,
              mt: '3px',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {value || '—'}
          </Typography>
        )}
      </Box>
    </Box>
  );
}

function PriceRow({ label, value, highlight, dim }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        py: 1,
        borderBottom: `1px dashed ${T.divider}`,
        '&:last-child': { borderBottom: 'none' },
      }}
    >
      <Typography
        sx={{
          fontSize: '0.82rem',
          color: dim ? T.textMuted : T.textSub,
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontSize: highlight ? '1rem' : '0.9rem',
          fontWeight: highlight ? 700 : 500,
          color: highlight ? T.green : T.text,
        }}
      >
        {value}
      </Typography>
    </Box>
  );
}

export default function SessionCheckout({ onLogout }) {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { userId } = useAuth();

  const { expert, date, time, duration, price: basePrice, appointmentTypeId } = state || {};

  const [backendPrice, setBackendPrice] = useState(null);
  const [userData, setUserData] = useState({
    name: '',
    surname: '',
    email: '',
    contact: '',
  });
  const [isChecked, setIsChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [couponCode, setCouponCode] = useState('');
  const [couponApplied, setCouponApplied] = useState(false);
  const [couponPct, setCouponPct] = useState(0);
  const [csrfToken, setCsrfToken] = useState('');
  const [couponError, setCouponError] = useState('');

  const GST_RATE = 0.18;
  const GATEWAY_RATE = 0.02;
  const gst = parseFloat((basePrice * GST_RATE).toFixed(2));
  const subtotal = parseFloat((basePrice + gst).toFixed(2));
  const discounted = couponApplied
    ? parseFloat((subtotal * (1 - couponPct / 100)).toFixed(2))
    : subtotal;
  const gateway = parseFloat((discounted * GATEWAY_RATE).toFixed(2));
  const totalPay = parseFloat((discounted + gateway).toFixed(2));

  useEffect(() => {
    if (!userId) return;
    api
      .get(`${API_URL}/get_user_data/?user_id=${userId}`)
      .then((res) => setUserData(res.data))
      .catch((err) => console.error('get_user_data error', err));

    api
      .get(`${API_URL}/get-csrf-token/`, { withCredentials: true })
      .then((res) => setCsrfToken(res.data.csrfToken))
      .catch((err) => console.error('csrf error', err));
  }, [userId]);

  const handleApplyCoupon = async () => {
    if (!couponCode.trim()) {
      setCouponError('Enter a coupon code.');
      return;
    }
    setCouponError('');
    setLoading(true);
    try {
      const res = await api.post(`${API_URL}/api/validate-coupon/`, {
        coupon_code: couponCode,
      });
      if (res.status === 200) {
        setCouponPct(res.data.discount);
        setCouponApplied(true);
      }
    } catch (e) {
      setCouponApplied(false);
      setCouponPct(0);
      setCouponError('Invalid or expired coupon.');
    } finally {
      setLoading(false);
    }
  };

  const handleRemoveCoupon = () => {
    setCouponCode('');
    setCouponApplied(false);
    setCouponPct(0);
    setCouponError('');
  };

  const handlePay = async () => {
    if (!isChecked) return;
    setLoading(true);

    try {
      const orderRes = await fetch(`${API_URL}/create-order/`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          amount: Math.round(totalPay * 100),
          expert_id: expert?.id,
          appointment_type_id: appointmentTypeId,
          date,
          time,
          notes: state?.notes || '',
          coupon_code: couponApplied ? couponCode : null,
        }),
      });

      if (!orderRes.ok) {
        const txt = await orderRes.text();
        throw new Error(`Order failed (${orderRes.status}): ${txt}`);
      }
      const resData = await orderRes.json();

      const {
        order_id,
        amount,
        currency,
        key,
        booking_id,
        name,
        email,
        contact,
        breakdown,
      } = resData;
      setBackendPrice(breakdown);

      if (!order_id) throw new Error('No order_id returned from server');

      await new Promise((resolve) => {
        if (window.Razorpay) return resolve();
        const s = document.createElement('script');
        s.src = 'https://checkout.razorpay.com/v1/checkout.js';
        s.onload = resolve;
        document.body.appendChild(s);
      });

      const options = {
        key,
        amount: Math.round(totalPay * 100),
        currency,
        order_id,
        name: 'Anthrasync',
        description: `Session with ${expert?.name}`,
        prefill: { name, email, contact },
        theme: { color: T.blue },
        handler: async (rzpRes) => {
          try {
            const verifyRes = await fetch(`${API_URL}/verify-payment/`, {
              method: 'POST',
              headers: {
                Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                razorpay_payment_id: rzpRes.razorpay_payment_id,
                razorpay_order_id: rzpRes.razorpay_order_id,
                razorpay_signature: rzpRes.razorpay_signature,
                booking_id,
              }),
            });

            if (!verifyRes.ok) throw new Error('Payment verification failed');

            const result = await verifyRes.json();
            if (result.success) {
              await api
                .post(
                  `${API_URL}/create_transactions_session_booking/`,
                  {
                    user_id: userId,
                    booking_id: result.booking_id,
                    order_id: rzpRes.razorpay_order_id,
                    transaction_id: rzpRes.razorpay_payment_id,
                    amount: totalPay,
                    status: 'success',
                    payment_reason: 'Session Booking',
                  },
                  {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                    },
                  }
                )
                .catch((err) =>
                  console.log('Transaction saving error:', err.response?.data)
                );

              navigate('/transactions', {
                state: {
                  paymentId: rzpRes.razorpay_payment_id,
                  expert,
                  date,
                  time,
                },
              });
            } else {
              alert('Payment verified but booking failed. Contact support.');
            }
          } catch (err) {
            alert('Verification error: ' + err.message);
          } finally {
            setLoading(false);
          }
        },
        modal: {
          ondismiss: async () => {
            try {
              await api.post(
                `${API_URL}/create_transactions_session_booking/`,
                {
                  user_id: userId,
                  booking_id,
                  order_id,
                  transaction_id: null,
                  amount: breakdown.final_amount,
                  status: 'failure',
                  payment_reason: 'Session Booking',
                },
                {
                  headers: {
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                  },
                }
              );
            } catch (err) {
              console.error('Failed to save cancelled transaction', err);
            }
            setLoading(false);
          },
        },
      };

      new window.Razorpay(options).open();
    } catch (err) {
      alert('Payment failed: ' + err.message);
      setLoading(false);
    }
  };

  const handlePhonePePayment = async () => {
    if (!isChecked) return;

    try {
      setLoading(true);
      const res = await api.post("/phonepe-payment/", {
  amount: totalPay,
  expert_id: expert.id,
  appointment_type_id: appointmentTypeId,
  date,
  time,
  notes:state?.notes || '',
});
      const bookingId = res.data?.booking_id;
      const redirectUrl = res.data?.redirectUrl;
      const orderId = res.data?.orderId;
      console.log("PHONEPE DATA:", {
  booking_id: state?.booking_id,
});

      localStorage.setItem('phonepe_order_id', orderId);
      localStorage.setItem(
        'phonepe_payment_data',
        JSON.stringify({
          user_id: userId,
          booking_id: bookingId,
          amount: totalPay,
          plan: 'Session Booking',
        })
      );

      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else {
        alert('PhonePe initialization failed');
        setLoading(false);
      }
    } catch (err) {
      console.error(err);
      alert('PhonePe payment failed');
      setLoading(false);
    }
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.08, duration: 0.35, ease: 'easeOut' },
    }),
  };

  const fullName = `${userData.name} ${userData.surname}`.trim();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background:
          'radial-gradient(circle at top, #10152b 0, #020308 42%, #010103 100%)',
        color: T.text,
      }}
    >
      <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 1300 }}>
        <Header1 onLogout={onLogout} />
      </Box>

      <Container
        maxWidth="md"
        sx={{
          pt: { xs: 11, sm: 13 },
          pb: 10,
          px: { xs: 2, sm: 3 },
        }}
      >
        {/* Top summary strip */}
        <Box
          sx={{
            mb: { xs: 4, sm: 5 },
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: { xs: 'flex-start', sm: 'center' },
            justifyContent: 'space-between',
            gap: 2,
          }}
        >
          <Box>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: { xs: '1.7rem', sm: '2.1rem' },
                background: 'linear-gradient(90deg, #c8d0e8, #4f9eff)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                letterSpacing: '-0.01em',
              }}
            >
              Session Checkout
            </Typography>
            <Typography
              sx={{
                color: T.textSub,
                fontSize: '0.9rem',
                mt: 0.8,
              }}
            >
              Confirm your details and complete the secure payment.
            </Typography>
          </Box>
          <Box
            sx={{
              borderRadius: '16px',
              px: 2,
              py: 1.2,
              background: 'rgba(35,134,54,0.12)',
              border: `1px solid rgba(46,160,67,0.4)`,
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'flex-start', sm: 'flex-end' },
              gap: 0.2,
            }}
          >
            <Typography
              sx={{ fontSize: '0.75rem', color: T.textMuted, textTransform: 'uppercase' }}
            >
              Total payable
            </Typography>
            <Typography sx={{ fontSize: '1.4rem', fontWeight: 800, color: T.green }}>
              ₹{backendPrice?.final_amount || totalPay}
            </Typography>
            <Typography sx={{ fontSize: '0.74rem', color: T.textMuted }}>
              Incl. GST and gateway charges
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={{ xs: 2.5, sm: 3 }} justifyContent="center">
          {/* Left column */}
          <Grid item xs={12} md={5}>
            <Stack spacing={2.5}>
              {/* Session summary */}
              <motion.div
                custom={0}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
              >
                <SectionCard
                  title="Session Summary"
                  subtitle="Review your expert and selected slot."
                  accent={T.blue}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: 1.5,
                      p: 2,
                      mb: 2.5,
                      borderRadius: '16px',
                      background:
                        'linear-gradient(135deg, rgba(56,139,253,0.18), rgba(9,105,218,0.16))',
                      border: `1px solid rgba(56,139,253,0.5)`,
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Avatar
                        src={expert?.image || undefined}
                        sx={{
                          width: 52,
                          height: 52,
                          flexShrink: 0,
                          background: 'linear-gradient(135deg,#0d2145,#1a3a6e)',
                          color: '#6ea8ff',
                          fontWeight: 700,
                          border: `1.5px solid rgba(166,198,255,0.7)`,
                        }}
                      >
                        {!expert?.image && expert?.name?.charAt(0).toUpperCase()}
                      </Avatar>
                      <Box>
                        <Typography
                          sx={{
                            fontWeight: 600,
                            color: T.text,
                            fontSize: '0.98rem',
                          }}
                        >
                          {expert?.name}
                        </Typography>
                        <Typography sx={{ color: '#9ec2ff', fontSize: '0.75rem', mt: 0.4 }}>
                          {expert?.title || 'Expert'}
                        </Typography>
                      </Box>
                    </Box>
                    <Tooltip title="Base session price before GST & gateway fee">
                      <Chip
                        size="small"
                        icon={<LocalOfferIcon sx={{ fontSize: 15 }} />}
                        label={`₹${basePrice}`}
                        sx={{
                          borderRadius: '999px',
                          background: 'rgba(0,0,0,0.24)',
                          border: `1px solid rgba(201,209,217,0.16)`,
                          color: T.text,
                          fontWeight: 600,
                          fontSize: '0.8rem',
                          px: 0.5,
                        }}
                      />
                    </Tooltip>
                  </Box>

                  <InfoRow icon={<CalendarMonthIcon />} label="Date" value={fmtDate(date)} />
                  <InfoRow icon={<AccessTimeIcon />} label="Time" value={fmtTime(time)} />
                  <InfoRow
                    icon={<TimerIcon />}
                    label="Duration"
                    value={duration}
                    pill
                  />
                </SectionCard>
              </motion.div>

              {/* Personal info */}
              <motion.div
                custom={1}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
              >
                <SectionCard
                  title="Your Details"
                  subtitle="These details will be used for communication and receipt."
                  accent={T.blue}
                >
                  <InfoRow
                    icon={<PersonIcon />}
                    label="Full Name"
                    value={fullName || '—'}
                  />
                  <InfoRow icon={<EmailIcon />} label="Email" value={userData.email} />
                  <InfoRow icon={<PhoneIcon />} label="Contact" value={userData.contact} />
                  <Typography
                    sx={{
                      mt: 1.5,
                      fontSize: '0.75rem',
                      color: T.textMuted,
                    }}
                  >
                    Need changes? Update your profile information before completing the
                    payment.
                  </Typography>
                </SectionCard>
              </motion.div>
            </Stack>
          </Grid>

          {/* Right column */}
          <Grid item xs={12} md={5}>
            <Stack spacing={2.5}>
              {/* Pricing */}
              <motion.div
                custom={2}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
              >
                <SectionCard
                  title="Pricing"
                  subtitle="A transparent breakdown of your session cost."
                  accent={T.blue}
                >
                  <PriceRow label="Base Price" value={`₹${basePrice}`} />
                  <PriceRow
                    label="GST (18%)"
                    value={`₹${backendPrice?.gst || gst}`}
                    dim
                  />
                  {couponApplied && (
                    <PriceRow
                      label={`Coupon (${couponPct}% off)`}
                      value={`-₹${(subtotal * (couponPct / 100)).toFixed(2)}`}
                      dim
                    />
                  )}
                  <PriceRow
                    label="Gateway Fee (2%)"
                    value={`₹${backendPrice?.gateway_fee || gateway}`}
                    dim
                  />
                  <PriceRow
                    label="Total Payable"
                    value={`₹${backendPrice?.final_amount || totalPay}`}
                    highlight
                  />

                  <Box sx={{ mt: 2.5 }}>
                    {couponApplied ? (
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          px: 2,
                          py: 1.2,
                          borderRadius: '12px',
                          background: T.greenDim,
                          border: `1px solid ${T.greenBorder}`,
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CheckCircleIcon sx={{ fontSize: 16, color: T.green }} />
                          <Typography
                            sx={{
                              fontSize: '0.82rem',
                              color: T.green,
                              fontWeight: 600,
                            }}
                          >
                            {couponPct}% off applied
                          </Typography>
                        </Box>
                        <Button
                          size="small"
                          onClick={handleRemoveCoupon}
                          sx={{
                            fontSize: '0.72rem',
                            color: T.red,
                            textTransform: 'none',
                            p: 0,
                            '&:hover': { color: '#ff4b4b' },
                          }}
                        >
                          Remove
                        </Button>
                      </Box>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Have a coupon?"
                            value={couponCode}
                            onChange={(e) => {
                              setCouponCode(e.target.value);
                              if (couponError) setCouponError('');
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '12px',
                                background: 'rgba(255,255,255,0.02)',
                                color: T.text,
                                fontSize: '0.85rem',
                                '& fieldset': { borderColor: T.cardBorder },
                                '&:hover fieldset': { borderColor: T.blueBorder },
                                '&.Mui-focused fieldset': { borderColor: T.blue },
                              },
                              '& input::placeholder': { color: T.textMuted },
                              '& input': { color: T.text },
                            }}
                          />
                          <Button
                            variant="outlined"
                            onClick={handleApplyCoupon}
                            disabled={loading}
                            sx={{
                              borderRadius: '12px',
                              px: 2.5,
                              flexShrink: 0,
                              fontSize: '0.8rem',
                              fontWeight: 600,
                              textTransform: 'none',
                              color: T.blue,
                              borderColor: T.blueBorder,
                              '&:hover': {
                                background: T.blueDim,
                                borderColor: T.blue,
                              },
                            }}
                          >
                            Apply
                          </Button>
                        </Box>
                        {couponError && (
                          <Typography
                            sx={{
                              fontSize: '0.72rem',
                              color: T.red,
                              mt: 0.2,
                            }}
                          >
                            {couponError}
                          </Typography>
                        )}
                      </Box>
                    )}
                  </Box>
                </SectionCard>
              </motion.div>

              {/* Confirm & Pay */}
              <motion.div
                custom={3}
                variants={cardVariants}
                initial="hidden"
                animate="visible"
              >
                <SectionCard
                  title="Confirm & Pay"
                  subtitle="Check everything once and choose a payment method."
                  accent={T.green}
                  dense
                >
                  <Box
                    sx={{
                      px: 2.2,
                      py: 1.8,
                      borderRadius: '16px',
                      background:
                        'radial-gradient(circle at left, rgba(46,160,67,0.22), transparent 60%)',
                      border: `1px solid rgba(63,185,80,0.6)`,
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      mb: 2.2,
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ fontSize: '0.78rem', color: T.textMuted, mb: 0.4 }}
                      >
                        You will be charged
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: '1.5rem',
                          fontWeight: 800,
                          color: T.green,
                        }}
                      >
                        ₹{backendPrice?.final_amount || totalPay}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: '0.75rem',
                        color: T.textMuted,
                        maxWidth: 160,
                        textAlign: 'right',
                      }}
                    >
                      By continuing, you agree to our terms of service and refund policy.
                    </Typography>
                  </Box>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={(e) => setIsChecked(e.target.checked)}
                        sx={{
                          color: T.textMuted,
                          '&.Mui-checked': { color: T.blue },
                          '& .MuiSvgIcon-root': { fontSize: 18 },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: '0.8rem', color: T.textSub }}>
                        I confirm that the session details and contact information are
                        correct.
                      </Typography>
                    }
                    sx={{
                      mb: 2.3,
                      alignItems: 'flex-start',
                      '& .MuiFormControlLabel-label': { mt: '1px' },
                    }}
                  />

                  <Button
                    fullWidth
                    variant="contained"
                    onClick={handlePay}
                    disabled={!isChecked || loading}
                    startIcon={
                      loading ? (
                        <CircularProgress size={16} sx={{ color: 'inherit' }} />
                      ) : null
                    }
                    sx={{
                      borderRadius: '14px',
                      py: 1.4,
                      fontSize: '0.9rem',
                      fontWeight: 700,
                      textTransform: 'none',
                      letterSpacing: '0.02em',
                      mb: 1.2,
                      background: isChecked
                        ? 'linear-gradient(90deg, #00b85a, #00e676)'
                        : 'rgba(0,230,118,0.08)',
                      boxShadow: isChecked
                        ? '0 10px 30px rgba(0,230,118,0.36)'
                        : 'none',
                      color: isChecked ? '#001a0d' : T.textMuted,
                      border: `1px solid ${
                        isChecked ? 'rgba(0,230,118,0.4)' : T.cardBorder
                      }`,
                      transition: 'all 0.22s ease',
                      '&:hover': {
                        background:
                          'linear-gradient(90deg, #00cc66, #00ff88)',
                        boxShadow:
                          '0 14px 38px rgba(0,230,118,0.45)',
                        transform: 'translateY(-1px)',
                      },
                      '&:active': { transform: 'scale(0.985)' },
                      '&:disabled': {
                        background: 'rgba(0,230,118,0.06)',
                        color: T.textMuted,
                        boxShadow: 'none',
                      },
                    }}
                  >
                    {loading ? 'Processing…' : 'Pay with Razorpay'}
                  </Button>

                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={handlePhonePePayment}
                    disabled={!isChecked || loading}
                    sx={{
                      borderRadius: '14px',
                      py: 1.35,
                      fontSize: '0.9rem',
                      fontWeight: 700,
                      textTransform: 'none',
                      color: '#5f259f',
                      borderColor: '#5f259f',
                      '&:hover': {
                        background: 'rgba(95,37,159,0.12)',
                        borderColor: '#5f259f',
                      },
                    }}
                  >
                    Pay with PhonePe
                  </Button>

                  <Typography
                    sx={{
                      textAlign: 'center',
                      fontSize: '0.7rem',
                      color: T.textMuted,
                      mt: 1.6,
                    }}
                  >
                    Payments are processed securely via Razorpay with 256-bit SSL
                    encryption.
                  </Typography>
                </SectionCard>
              </motion.div>
            </Stack>
          </Grid>
        </Grid>
      </Container>

      {/* Scroll to top */}
      <IconButton
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        sx={{
          position: 'fixed',
          bottom: 20,
          right: 20,
          background: 'rgba(79,158,255,0.16)',
          border: `1px solid ${T.blueBorder}`,
          color: T.blue,
          '&:hover': { background: T.blueDim },
        }}
      >
        <ArrowUpwardIcon sx={{ fontSize: 18 }} />
      </IconButton>

      {/* Full-screen loading overlay */}
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            zIndex: 2000,
            background: 'rgba(4,5,12,0.80)',
            backdropFilter: 'blur(6px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <CircularProgress
            size={52}
            thickness={5}
            sx={{
              color: 'transparent',
              '& .MuiCircularProgress-circle': { stroke: 'url(#pg)' },
            }}
          />
          <svg width="0" height="0">
            <defs>
              <linearGradient id="pg" x1="1" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#4f9eff" />
                <stop offset="100%" stopColor="#00e676" />
              </linearGradient>
            </defs>
          </svg>
          <Typography sx={{ color: T.text, fontSize: '0.88rem' }}>
            Processing your payment…
          </Typography>
        </Box>
      )}
    </Box>
  );
}